import { Skeleton } from '@/components/ui/skeleton';

export default function MessagesLoading() {
  return (
    <div className="min-h-screen bg-background pb-20">
      {/* Search bar skeleton */}
      <div className="sticky top-0 z-40 border-b bg-background p-4">
        <Skeleton className="h-12 w-full rounded-md" />
      </div>

      {/* Conversation list skeleton */}
      <div className="mx-auto max-w-screen-sm">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="flex items-center gap-4 p-4 border-b">
            <Skeleton className="h-14 w-14 rounded-full shrink-0" />
            <div className="flex-1 space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-4 w-32" />
                <Skeleton className="h-3 w-12" />
              </div>
              <Skeleton className="h-3 w-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
